import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrderAutomatizaionRow } from '@/Types';
import { asyncActions } from './asyncActions';
import { OrderAutomatizationPackageModel } from '@/Models/OrderUserProducts/OrderAutomatizationPackageModel';
import { orderMapping } from '@/Mapping/OrderMapping';

export type OrderAutomatizationModalState = {
  editableOrderIds: number[];
  orderAutomatizaionRows: OrderAutomatizaionRow[];
  orderPackages: {
    orderId: number;
    isContractsConfigured: boolean;
    isOwnContract: boolean;
    packages: OrderAutomatizationPackageModel[];
  }[];
};

const initialState: OrderAutomatizationModalState = {
  editableOrderIds: [],
  orderAutomatizaionRows: [],
  orderPackages: [],
};

const orderAutomatizaionSlice = createSlice({
  name: 'orderAutomatization',
  initialState,
  reducers: {
    setSelectedOrders(state, action: PayloadAction<number[]>) {
      state.editableOrderIds = action.payload;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.getOrdersAutomatizationRequest.fulfilled, (state, action) => {
        state.orderAutomatizaionRows = action.payload.orders.map(orderMapping.getOrderAutomatizaionRow);
      })
      .addCase(asyncActions.getPackagesForOrderRequest.fulfilled, (state, action) => {
        if (action.payload) {
          state.orderPackages.push(action.payload);
        } // if
      })
      .addCase(asyncActions.getLogisticProducts.fulfilled, (state, action) => {
        const { orderId, packageId, orderUserProductModels } = action.payload;
        const orderIdx = state.orderPackages.findIndex((value) => value.orderId == orderId && !value.isOwnContract);
        const packageIdx = state.orderPackages[orderIdx].packages.findIndex((value) => value.packageId == packageId);

        state.orderPackages[orderIdx].packages[packageIdx].products = [...orderUserProductModels];
      });
  },
});

const { actions, reducer } = orderAutomatizaionSlice;

export const orderAutomatizationReducer = reducer;
export const orderAutomatizationActions = actions;
export const orderAutomatizationAsyncActions = asyncActions;
